import { useState } from "react";
// models
import {
  ConvocatoriasFechasBEPSModel,
  initialValuesConvocatoriasFechasBEPSModel,
} from "../../../../../models/ConvocatoriasBepsModel/convocatoriasbeps.model";
// api services
import apiConvocatorias from "../../../../../api/Convocatorias/api-convocatorias";
import moment from "moment";
import { openNotification } from "../../../../../utils/saveFile";
import { useEncrypt } from "../../../../../hooks/useEncrypt";

export const useCronogramaActividades = () => {
  // redux
  // const { idConvocatoria } = useSelector((state: any) => state.convocatoria);
  const { decrypt, encrypt } = useEncrypt();
  //   state
  const [fechasbeps, setFechasBeps] = useState<ConvocatoriasFechasBEPSModel>(initialValuesConvocatoriasFechasBEPSModel);


  const guardarycontinuar = async (cambiarPestaña: any) => {
    let apertura = new Date(moment(fechasbeps.fecha_apertura).format('YYYY/MM/DD')).getTime()
    let cierre = new Date(moment(fechasbeps.fecha_cierre).format('YYYY/MM/DD')).getTime()
    let inscritos = new Date(moment(fechasbeps.fecha_informeinscritos).format('YYYY/MM/DD')).getTime()
    let subsanacion = new Date(moment(fechasbeps.fecha_subsanacion).format('YYYY/MM/DD')).getTime()
    let listadoInscritos = new Date(moment(fechasbeps.fecha_finalinscritos).format('YYYY/MM/DD')).getTime()
    const idConvocatoria = await decrypt(localStorage.getItem("id_convocatoria"));
    
    if(apertura >= cierre){
      return openNotification({
        titulo: "Error",
        descripcion: "La fecha de apertura debe ser menor que la fecha de cierre",
        placement: "bottomRight",
      });
    }else if(cierre >= inscritos ){
      return openNotification({
        titulo: "Error",
        descripcion: "La fecha de cierre debe ser menor que la fecha de informe de inscritos",
        placement: "bottomRight",
      });
    }else if(inscritos >= subsanacion ) {
      return openNotification({
        titulo: "Error",
        descripcion: "La fecha de informe de inscritos debe ser menor que la fecha de subsanación",
        placement: "bottomRight",
      });
    }else if(subsanacion >= listadoInscritos) {
      return openNotification({
        titulo: "Error",
        descripcion: "La fecha de subsanación debe ser menor que la fecha de final inscritos",
        placement: "bottomRight",
      });
    }

    let todasfechas = [];
    todasfechas.push({
      id: 1,
      id_convocatoria: idConvocatoria,
      clave: "Apertura",
      valormin: fechasbeps.fecha_apertura,
      valormax: "",
    });
    todasfechas.push({
      id: 2,
      id_convocatoria: idConvocatoria,
      clave: "Cierre",
      valormin: fechasbeps.fecha_cierre,
      valormax: "",
    });
    todasfechas.push({
      id: 3,
      id_convocatoria: idConvocatoria,
      clave: "Informe de inscritos",
      valormin: fechasbeps.fecha_informeinscritos,
      valormax: "",
    });
    todasfechas.push({
      id: 4,
      id_convocatoria: idConvocatoria,
      clave: "Subsanacion",
      valormin: fechasbeps.fecha_subsanacion,
      valormax: "",
    });
    todasfechas.push({
      id: 5,
      id_convocatoria: idConvocatoria,
      clave: "Listado final de inscritos",
      valormin: fechasbeps.fecha_finalinscritos,
      valormax: "",
    });
    
    await apiConvocatorias.guardarFechas(idConvocatoria, todasfechas);
    localStorage.setItem('cambiarPestaña', encrypt("3"))
    return cambiarPestaña("3");
  };
  return {
    fechasbeps,
    setFechasBeps,
    guardarycontinuar,

  };
};
